import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CreateAdventure, AdventureDto, UpdateAdventure } from './partite-dto';

@Injectable({
  providedIn: 'root'
})
export class GestionePartiteService {

  private url = `${environment.apiUrl}/adventures`;

  constructor(private http: HttpClient) { }



  getAll(): Observable<AdventureDto[]> {
    return this.http.get<AdventureDto[]>(`${this.url}`);
  }

  create(data: CreateAdventure): Observable<AdventureDto> {
    return this.http.post<AdventureDto>(`${this.url}`, data);
  }

  read(id: string): Observable<AdventureDto> {
    return this.http.get<AdventureDto>(`${this.url}/${id}`);
  }

  update(id: string, data: UpdateAdventure): Observable<AdventureDto> {
    return this.http.put<AdventureDto>(`${this.url}/${id}`, data);
  }

  delete(id: string): Observable<void> {
    return this.http.delete<void>(`${this.url}/${id}`);
  }

}
